export default "__VITE_ASSET__4cd41213__"